import { render, staticRenderFns } from "./PlaceIcon.vue?vue&type=template&id=771df08f"
import script from "./PlaceIcon.vue?vue&type=script&lang=js"
export * from "./PlaceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports